// Which ContentIQ format a NeTrA product derives. Mirrors the backend's
// format_serves() (app/contentiq/routers/projects.py) so the wizard and the
// server agree: case is ignored and any run of spaces or dashes counts as one
// space, and a format's own name counts as well as its netra_product_names —
// so the NeTrA product "Content Syndication - 2-Touch" (its prod name,
// 2026-10-28) derives the format "Content Syndication – 2 Touch".
export function normProductName(name) {
  return String(name || '').toLowerCase().split(/[\s\-–—]+/).filter(Boolean).join(' ');
}

export function formatServes(format, productNames) {
  const wanted = new Set((productNames || []).map(normProductName));
  const names = [...(format?.netra_product_names || []), format?.format_name];
  return names.some(n => n && wanted.has(normProductName(n)));
}

// The one format the products derive, or null when none or several match.
export function deriveFormat(formats, productNames) {
  if (!(productNames || []).length) return null;
  const matches = (formats || []).filter(f => formatServes(f, productNames));
  return matches.length === 1 ? matches[0] : null;
}
